export const MENU_ID_SITE = {
  ART_PRODUIT_MALAGASY: 1,
  EVENEMENT_SEMINAIRE: 2,
  BIEN_ETRE_LOISIR: 3,
  GASTRONOMIE: 4,
  SERVICES: 5,
};
